import { ErrorMessage } from "@hookform/error-message";
import { useRef, useState,useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { useApiService } from "../../services";
import { useConfig } from "../../context/ConfigProvider";
import { notify } from "../../utils";
import { NotifyType, PageUrl } from "../../utils/app-config";
import { IForgetPassword } from "../../typings/models/ForgetPassword";
import Contaier from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
import Loader from "../../components/molecules/Loader";
import { setRecaptchaRef } from "../../services/axiosconfig";

  function ForgetPassword() {
  const cfg = useConfig();
  const site_Key: string = cfg.REACT_APP_SITE_KEY ?? "";
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const navigate = useNavigate();
  const { ForgetPassword } = useApiService();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IForgetPassword>();
  const [emailError, setEmailError] = useState("");
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const { message } = notify();
  useEffect(() => {
    setRecaptchaRef(recaptchaRef); // 🔗 give Axios access to the reCAPTCHA
  }, []);

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const email = pattern.test(value);
    let errMsg = "";
    if (!email) {
      errMsg = "Invalid email format. eg. abc@de.lk";
      setIsButtonEnabled(false);
    } else {
      errMsg = "";
      setIsButtonEnabled(true);
    }
    setEmailError(errMsg);
  };

  const onClickLogin = async () => {
    handleSubmit(async (password: IForgetPassword) => { 
      setLoading(false);
      setSubmitted(true);
      const reCaptchaResponse = recaptchaRef.current?.getValue();
      if (!reCaptchaResponse) {
        setIsCaptchaValid(false);
        return;
      }
     
      setLoading(true);   
      let status = await ForgetPassword(password);
      setLoading(false);
     
      if (status && status == "Success") {
        message(
          NotifyType.Success,
          "Password reset successfully. The new password has been sent to your email address. Please check your inbox."
        );
        navigate(PageUrl.Login);
      } else {
        setIsCaptchaValid(false);
        recaptchaRef?.current?.reset();       
        message(
          NotifyType.Error,
          "User Authentication failed. Please try again."
        );
      }
      setSubmitted(false);
    })();
  };

  return (
    <>
      <Header />
      <Contaier>
        <div className="inner-content">
          <div className="container">
            <div className="landing-page form-upload">
              <div className="row justify-content-center">
                <div className="col-md-7 col-lg-5">
                  <div className="landing-list py-5 rounded-4">
                    <h2 className="text-center mb-4">Forget Password?</h2>
                    <div className="mb-3">
                      <label
                        htmlFor="validationServer03"
                        className="form-label"
                      >
                        Email Address
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Email"
                        id="Email"
                        {...register("Email", {
                          required: "Please enter email",
                          onChange(event) {
                            handleEmailChange(event);
                          },
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="Email"
                        render={({ message }) => (
                          <p className="errorMsgPassword mb-0">{message}</p>
                        )}
                      />
                      <p className="errorMsgPassword mb-0">{emailError}</p>
                    </div>
                    <div className="mb-3">
                        <ReCAPTCHA
                          ref={recaptchaRef}
                          sitekey={site_Key}
                          onChange={() => setIsCaptchaValid(true)}
                          onExpired={() => setIsCaptchaValid(false)}
                        />
                        {submitted && !isCaptchaValid && (
                          <div className="error-message">
                            Please complete the reCAPTCHA verification.
                          </div>
                        )}
                      </div>
                    <div className="text-center">
                      <button
                        type="button"
                        disabled={!isButtonEnabled || loading }
                        onClick={onClickLogin}
                        className="btn btn-success mt-4"
                      >
                        {loading ? <Loader /> : <>Submit</>}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Contaier>
      <Footer />
    </>
  );
}

export default ForgetPassword;
